import { render } from "./SiteFooter.vue?vue&type=template&id=7102976a&bindings={\"getYear\":\"options\"}"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"
script.render = render

export default script